import { FilterQueryParam } from '../../../result-filters'

export const SORT_FILTER_QUERY_PARAM = 'sort'

export const sortMethods: FilterQueryParam[] = [
    {
        displayName: 'Latest & Key Seats',
        paramName: 'latest',
    },
    {
        displayName: 'A-Z',
        paramName: 'a-z',
    },
    {
        displayName: 'Z-A',
        paramName: 'z-a',
    },
]

export type ElectionSortFilterOptions = typeof sortMethods
